import { Card, Checkbox, Grid, Icon, IconButton, InputLabel, Tooltip } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDModalMenus from "components/MDModalMenus";
import MDSelect from "components/MDSelect";
import MDTypography from "components/MDTypography";
import MDViewLog from "components/MDViewLog";
import { useMaterialUIController } from "context";
import DataTable from "examples/Tables/DataTable";
import DefaultCell from "layouts/dashboards/sales/components/DefaultCell";
import { useCallback, useEffect, useRef, useState } from "react";
import { trueOrFalseEnum } from "utils/Enums";
import { verifyVariable } from "utils/Functions";
import { post } from "utils/WebService";
import ProfileCreateEdit from "./ProfileCreateEdit";
import { useUser } from "context/UserContext";

export default function ProfileConsult() {

    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const [profileData, setProfileData] = useState([]);
    const [profileDataPages, setProfileDataPages] = useState(0);
    const [loadingTable, setLoadingTable] = useState(true);
    const [isCreateEdit, setIsCreateEdit] = useState(false);
    const [selectedProfileId, setSelectedProfileId] = useState(null);
    const [selectedIdInclusao, setSelectedIdInclusao] = useState(null);
    const [isLog, setIsLog] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [recordsTotal, setRecordsTotal] = useState(0);
    const [createCopy, setCreateCopy] = useState(false);
    const [dadosModalFuncinalidades, setDadosModalFuncinalidades] = useState(null);
    const [isModalFuncionalidades, setIsModalFuncionalidades] = useState(false);
    const [aplicar, setAplicar] = useState(false);

    const { tipoPerfilEnum } = useUser();

    const [filters, setFilters] = useState({
        nome: '',
        associaCliente: null,
        ativo: trueOrFalseEnum[1]
    });

    const tableState = useRef({
        pageSize: 10,
        pageIndex: 0,
        sorting: [],
        filtered: []
    });

    useEffect(() => {
        let filtered = [];
        filtered.push({ id: 'ativo', value: true });
        fetchData({ ...tableState, filtered });
    }, []);

    const fetchData = useCallback(({ pageSize, pageIndex, sorting, filtered }) => {
        setLoadingTable(true);

        const updatedTableState = {
            pageSize: pageSize ? pageSize : tableState.current.pageSize,
            pageIndex: (pageIndex == 0 || pageIndex) ? pageIndex : tableState.current.pageIndex,
            sorting: sorting ? sorting : tableState.current.sorting,
            filtered: filtered ? filtered : tableState.current.filtered,
        };

        tableState.current = updatedTableState;

        post("/profiles/list", {
            page: updatedTableState.pageIndex,
            pageSize: updatedTableState.pageSize,
            sorted: updatedTableState.sorting,
            filtered: updatedTableState.filtered,
        }).then(({ data, pages, recordsTotal }) => {
            setProfileDataPages(pages);
            setProfileData(data);
            setRecordsTotal(recordsTotal);
            setLoadingTable(false);
            setAplicar(false);
        }).catch(() => {
            setLoadingTable(false);
            setAplicar(false);
        });

        setRefresh(false);

    }, [refresh]);

    const backFunction = () => {
        setIsCreateEdit(false);
        setSelectedProfileId(null);
        setSelectedIdInclusao(null);
        setCreateCopy(false);
    }

    const handleRefresh = () => {
        setRefresh(true);
    };

    const userColumns = [
        {
            header: "nome",
            accessorKey: "nome",
            cell: info => <DefaultCell>{info.getValue() || ""}</DefaultCell>,
            isSorted: true
        },
        {
          header: "Tipo de perfil",
          accessorKey: "tipoPerfil",
          cell: info => {
            const tipo = tipoPerfilEnum?.find(ht => ht.code === info.getValue());
            const texto = tipo?.name ?? info.getValue() ?? "-";
            return <DefaultCell>{String(texto)}</DefaultCell>;
          },
        },
        {
            header: "descrição",
            accessorKey: "descricao",
            cell: info => <DefaultCell>{info.getValue() || ""}</DefaultCell>,
            isSorted: true
        },
        {
            header: "Associa Cliente",
            accessorKey: "associaCliente",
            cell: info => (
                <Checkbox
                    checked={info.getValue()}
                    disabled
                    color="primary"
                    inputProps={{ 'aria-label': 'Associa Cliente' }}
                />
            ),
            isSorted: false
        },

        {
            header: "Ativo",
            accessorKey: "ativo",
            cell: info => (
                <Checkbox
                    checked={info.getValue()}
                    disabled
                    color="primary"
                    inputProps={{ 'aria-label': 'Ativo' }}
                />
            ),
            isSorted: false
        },
        {
            header: "funcionalidades",
            accessorKey: "funcionalidades",
            isSorted: false,
            cell: info => (
                <Tooltip title="Funcionalidades">
                    <IconButton onClick={() => {
                        handleModalFuncionalidades(info.getValue())
                    }}>
                        <MDTypography variant="h4">
                            <Icon color="inherit" sx={{ marginRight: 1 }}>build</Icon>
                        </MDTypography>
                    </IconButton>
                </Tooltip>
            ),
            width: "6%"
        },
        {
            header: "ações",
            isSorted: false,
            cell: info => (
                <>
                    <Tooltip title="Editar Perfil">
                        <IconButton
                            onClick={() => {
                                setSelectedProfileId(info.row.original.id);
                                setIsCreateEdit(true);
                            }}>
                            <MDTypography variant="h4">
                                <Icon color="inherit" sx={{ marginRight: 1 }}>edit</Icon>
                            </MDTypography>
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Copiar para criar novo serviço">
                        <IconButton
                            onClick={() => {
                                setSelectedProfileId(info.row.original.id);
                                setIsCreateEdit(true);
                                setCreateCopy(true);
                            }}>
                            <MDTypography variant="h4">
                                <Icon color="inherit" sx={{ marginRight: 1 }}>content_copy</Icon>
                            </MDTypography>
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Log">
                        <IconButton
                            onClick={() => handleOpenModal(info.row.original.inclusaoAlteracaoSistemaId)}>
                            <MDTypography variant="h4">
                                <Icon color="inherit" sx={{ marginRight: 1 }}>search</Icon>
                            </MDTypography>
                        </IconButton>
                    </Tooltip>
                </>
            ),
            width: "15%"
        },
    ];

    const handleApplyFilter = () => {
        let filtered = [];

        Object.keys(filters).forEach(filterKey => {
            if (verifyVariable(filters[filterKey]))
                if (filterKey == "nome") {
                    filtered.push({ id: filterKey, value: filters[filterKey] });
                } else if (filterKey == "ativo") {
                    if (filters.ativo?.value != null) {
                        filtered.push({ id: filterKey, value: filters.ativo?.value });
                    }
                } else {
                    filtered.push({ id: filterKey, value: filters.situacao?.id == 1 ? '' : filters[filterKey] });
                }
        })
        setAplicar(true);
        fetchData({ ...tableState, filtered });
    };

    const handleCleanFilter = () => {
        setFilters({
            nome: '',
            associaCliente: null,
            ativo: trueOrFalseEnum[1]
        })
        const updatedTableState = {
            pageSize: 10,
            pageIndex: 0,
            sorting: [],
            filtered: []
        };

        let filtered = [];
        filtered.push({ id: 'ativo', value: true });

        tableState.current = updatedTableState;
        fetchData({ ...updatedTableState, filtered });
    };

    const handleOpenModal = (id) => {
        setSelectedIdInclusao(id);
        setIsLog(true);
    };

    const handleCloseModal = () => {
        setIsLog(false);
        setSelectedIdInclusao(null);
        setDadosModalFuncinalidades(null);
        setIsModalFuncionalidades(false);
    };

    const handleModalFuncionalidades = (dados) => {
        setIsModalFuncionalidades(true);
        setDadosModalFuncinalidades(dados);
    };

    return (
        <Grid container display="flex" justifyContent="center">
            {isLog &&
                <MDViewLog
                    id={selectedIdInclusao}
                    show={isLog}
                    close={handleCloseModal}
                />

            }
            {isModalFuncionalidades &&
                <MDModalMenus
                    open={isModalFuncionalidades}
                    onClose={handleCloseModal}
                    dados={dadosModalFuncinalidades}
                    isProfile={true}
                />
            }

            {isCreateEdit &&
                <Grid item xs={12} md={12}>
                    <ProfileCreateEdit
                        profileId={selectedProfileId}
                        closeCreateEdit={backFunction}
                        refreshTable={handleRefresh}
                        createCopy={createCopy} />
                </Grid>
            }
            <Grid item xs={12} md={12} sx={{ display: isCreateEdit ? "none" : "" }}>
                <Card
                    variant="outlined"
                    sx={{
                        px: 2,
                        py: 1.5,
                        mb: 2,
                        background: darkMode ? "#23233a" : "#fafafa",
                        borderColor: darkMode ? "#333" : "#ddd",
                    }}
                >
                    <Grid container spacing={1}>
                            <Grid item xs={12} sm={3}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Nome</InputLabel>
                                <MDInput
                                    size="small"
                                    placeholder="Informe o nome..."
                                    value={filters.nome}
                                    onChange={({ target }) => setFilters({ ...filters, nome: target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleApplyFilter();
                                        }
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Associa Cliente?</InputLabel>
                                <MDSelect
                                    isMulti={false}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.name}
                                    name="associaCliente"
                                    placeholder="Ambos"
                                    value={trueOrFalseEnum.find(({ value }) => value == filters.associaCliente) || null}
                                    options={trueOrFalseEnum}
                                    onChange={({ value }) => {
                                        setFilters({ ...filters, associaCliente: value })
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Ativo</InputLabel>
                                <MDSelect
                                    isMulti={false}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.name}
                                    name="ativo"
                                    placeholder="Ambos"
                                    value={filters.ativo}
                                    options={trueOrFalseEnum}
                                    onChange={selectedOptions => setFilters({ ...filters, ativo: selectedOptions })}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} display="flex" alignItems="center" justifyContent="space-between" pt={1}>
                                <MDBox>
                                    <MDButton
                                        size="medium"
                                        variant="contained"
                                        color="info"
                                        circular={false}
                                        iconOnly={false}
                                        onClick={() => {
                                            setSelectedProfileId(null);
                                            setIsCreateEdit(true);
                                        }}>
                                        Adicionar Perfil
                                    </MDButton>
                                </MDBox>
                                <MDBox>
                                    <MDButton size="medium" sx={{ marginRight: 2 }} variant="contained" color="info" circular={false} iconOnly={false} onClick={handleCleanFilter}>
                                        Limpar filtro
                                    </MDButton>
                                    <MDButton size="medium" variant="contained" color="info" circular={false} iconOnly={false} onClick={handleApplyFilter}>
                                        Aplicar filtro
                                    </MDButton>
                                </MDBox>
                            </Grid>
                        </Grid>
                </Card>
                <DataTable
                    loading={loadingTable}
                    columnData={userColumns}
                    data={profileData}
                    fetchData={fetchData}
                    totalPages={profileDataPages}
                    totalRecords={recordsTotal}
                    tableState={tableState}
                    changeFilter={aplicar} />
            </Grid>
        </Grid >
    );
}

